/**
 * Interceptor global para fetch que agrega automáticamente el header X-Database
 * a todas las requests que vayan al backend
 * 
 * 🛠 VERSIÓN CORREGIDA - Maneja FormData correctamente
 */

import { getCurrentDatabase } from './companyUtils';
import { BACKEND } from '../consts/backend';

// Guardar el fetch original antes de interceptarlo
const originalFetch = window.fetch;

// Reemplazar fetch globalmente con nuestro interceptor
window.fetch = function(url, options = {}) {
  // Solo interceptar si la URL es del backend o una URL relativa
  const isBackendUrl = typeof url === 'string' && (
    url.includes(BACKEND) || 
    url.startsWith('/') ||
    url.includes('127.0.0.1:5000') ||
    url.includes('localhost:5000')
  );
  
  if (isBackendUrl) {
    const currentDatabase = getCurrentDatabase();
    
    if (currentDatabase) {
      // 🔍 DETECTAR SI ES FormData - NO establecer Content-Type
      const isFormData = options.body instanceof FormData;
      
      const enhancedOptions = {
        ...options,
        headers: {
          // ✅ SOLO agregar Content-Type si NO es FormData
          ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
          ...options.headers,
          'X-Database': currentDatabase
        }
      };
      
      return originalFetch(url, enhancedOptions);
    }
  }
  
  // Para URLs externas o sin database, usar fetch original
  return originalFetch(url, options);
};

/* CODIGO VIEJO
/**
 * Interceptor global para fetch que agrega automáticamente el header X-Database
 * a todas las requests que vayan al backend
 

import { getCurrentDatabase } from './companyUtils';
import { BACKEND } from '../consts/backend';

// Guardar el fetch original antes de interceptarlo
const originalFetch = window.fetch;

// Reemplazar fetch globalmente con nuestro interceptor
window.fetch = function(url, options = {}) {
  // Solo interceptar si la URL es del backend o una URL relativa
  const isBackendUrl = typeof url === 'string' && (
    url.includes(BACKEND) || 
    url.startsWith('/') ||
    url.includes('127.0.0.1:5000') ||
    url.includes('localhost:5000')
  );
  
  if (isBackendUrl) {
    const currentDatabase = getCurrentDatabase();
    
    if (currentDatabase) {
      // Agregar header X-Database automáticamente
      const enhancedOptions = {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
          'X-Database': currentDatabase
        }
      };
      
      return originalFetch(url, enhancedOptions);
    }
  }
  
  // Para URLs externas o sin database, usar fetch original
  return originalFetch(url, options);
};*/